import React, { useState, ReactNode } from 'react'
// import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react'
// import { XMarkIcon } from '@heroicons/react/24/outline'
// import LogoLight from "../../assets/images/logo-light.svg";
// import Sidebar from './Sidebar';
import TopBar from './Topbar';
// import { navigation } from './navigationTypes';
// import { classNames } from '../../utils/utils';
import { Link, useLocation } from 'react-router-dom';

interface LayoutProps {
    title: string;
    children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ title, children }) => {
    const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
    const [isActiveIdx, setIsActiveIdx] = useState<number | null>(null);
    const location = useLocation();

    return (
        <div className='bg-gray-900'>
            {/* <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 xl:hidden">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
                />

                <div className="fixed inset-0 flex">
                    <DialogPanel
                        transition
                        className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
                    >
                        <TransitionChild>
                            <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                                <button type="button" onClick={() => setSidebarOpen(false)} className="-m-2.5 p-2.5">
                                    <span className="sr-only">Close sidebar</span>
                                    <XMarkIcon aria-hidden="true" className="size-6 text-white" />
                                </button>
                            </div>
                        </TransitionChild>
                        Sidebar component, swap this element with another sidebar if you like
                        <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 ring-1 ring-white/10 py-0">
                            <div className="flex h-16 shrink-0 items-center">
                                <img
                                    alt="agrifi logo"
                                    src={LogoLight}
                                    width={100}
                                    height={100}
                                    className="h-16 w-auto"
                                />
                            </div>
                            <nav className="flex flex-1 flex-col">
                                <ul className="flex flex-1 flex-col gap-y-5">
                                    <li>
                                        <ul className="-mx-2 space-y-1">
                                            {navigation.map((item) => (
                                                <li key={item.name}>
                                                    <Link
                                                        to={item.href}
                                                        className={classNames(
                                                             location.pathname === item.href
                                                                ? 'bg-gray-800 text-white'
                                                                : 'text-gray-400 hover:bg-gray-800 hover:text-white',
                                                            'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                                                        )}
                                                    >
                                                        <item.icon aria-hidden="true" className="size-6 shrink-0" />
                                                        {item.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                    <li className="-mx-6 mt-auto">
                                        <Link
                                            to="/"
                                            className="flex items-center gap-x-4 px-6 py-3 text-sm/6 font-semibold text-white hover:bg-gray-800"
                                        >
                                            <img
                                                alt="profile photo"
                                                height={100}
                                                width={100}
                                                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                                className="size-8 rounded-full bg-gray-800"
                                            />
                                            <span className="sr-only">Your profile</span>
                                            <span aria-hidden="true">Tom Cook</span>
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </DialogPanel>
                </div>
            </Dialog> */}

            {/* Static sidebar for desktop */}
            {/* <Sidebar isActiveIdx={isActiveIdx} setIsActiveIdx={setIsActiveIdx}/> */}

            <div className="">
                {/* Sticky search header */}

                <TopBar setSidebarOpen={setSidebarOpen}/>
                <h2 className="px-4 text-base/7 font-semibold text-white sm:px-6 lg:px-8 pt-6">{title}</h2>
                <main>
                    {children}
                </main>
            </div>
        </div>
    )
}

export default Layout